<div class="organization-structure mb-footer">
    <div class="container">
        <div class="row">
            <!-- section title -->
            <div class="col-md-12 my-md-5 mb-5 sec-title">
                <app-title-page [dataTitle]="dataTitle" [link]="'#board'"></app-title-page>
            </div>
            <!-- contens -->
            <div class="col-md-12" id="board">
                <div class="lane-top board">
                    <!-- commisioners -->
                    <div class="division">
                        <div class="title">
                            <h4 class="mb-0">{{ dataBOCTitle }}</h4>
                        </div>
                        <div class="row mt-4 justify-content-center px-md-2 px-3" *ngIf="dataBOC">
                            <div class="col-md-2 col-6 p-lg-2 p-1" *ngFor="let people of dataBOC">
                                <div class="pointer" (click)="showModal(people)">
                                    <app-people-photos [dataPeople]="people"></app-people-photos>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- directors -->
                    <div class="division mrgn-top">
                        <div class="title">
                            <h4 class="mb-0">{{ dataBODTitle }}</h4>
                        </div>
                        <div class="row mt-4 justify-content-center px-md-2 px-3" *ngIf="dataBOD">
                            <div class="col-md-2 col-6 p-lg-2 p-1" *ngFor="let people of dataBOD">
                                <div class="pointer" (click)="showModal(people)">
                                    <app-people-photos [dataPeople]="people"></app-people-photos>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- head of division -->
                    <!--<div class="division mrgn-top">
                        <div class="title w-hide"
                            (click)="showAccordion($event)">
                            <h4 class="mb-0">{{ dataHODTitle }}</h4>
                            <button class="btn red-btn-icon show-hide shown">  
                                Show Member
                                <img class="icon" src="../../../../assets/images/icon/eye.svg" alt="">
                            </button>
                            <button class="btn red-btn-icon show-hide hidden"> 
                                Hide Member 
                                <span class="icon-strip"></span>
                            </button>
                        </div>
                        <div class="warp-members mt-4 row" *ngIf="dataHOD">
                            <div class="col-md-11 mx-auto">
                                <div class="row justify-content-center px-lg-0 px-3">
                                    <div class="col-lg-3 col-md-4 col-6 p-md-3 p-1" *ngFor="let people of dataHOD">
                                        <app-people-nophotos [dataPeople]="people"></app-people-nophotos>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>-->
                    <!-- senior management -->
                    <!--<div class="division mrgn-top">
                        <div class="title mb-4 w-hide" 
                                (click)="showAccordion($event)">
                            <h4 class="mb-0">{{ dataSOMTitle }}</h4>
                            <button class="btn red-btn-icon show-hide shown"> 
                                Show Member
                                <img class="icon" src="../../../../assets/images/icon/eye.svg" alt="">
                            </button>
                            <button class="btn red-btn-icon show-hide hidden"> 
                                Hide Member 
                                <span class="icon-strip"></span>
                            </button>
                        </div>
                        <div class="warp-members row" *ngIf="dataSOM">
                            <div class="col-md-11 mx-auto">
                                <div class="row justify-content-center px-lg-0 px-3">
                                    <div class="col-lg-3 col-md-4 col-6 p-md-3 p-1" *ngFor="let people of dataSOM">
                                        <app-people-nophotos [dataPeople]="people"></app-people-nophotos>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>-->
                </div>
            </div>
        </div>
    </div>
     <!-- modal board -->
     <div *ngIf="isModalShown" 
        [config]="{ show: true }" 
        (onHidden)="onHidden()" 
        bsModal 
        #autoShownModal="bs-modal"
        class="modal fade modal-director"
        tabindex="-1" 
        role="dialog" 
        aria-labelledby="dialog-auto-name">
        <div class="modal-x" aria-label="Close" (click)="hideModal()">
            <span aria-hidden="true" class="d-flex align-items-center"><i class="icon ion-ios-close"></i> Close</span>
        </div>
        <div class="modal-dialog d-flex align-items-center h-100 my-0 py-4 modal-lg">
            <div class="modal-content">
                <div class="modal-body p-0 d-flex">
                    <div class="detail">
                        <h3 *ngIf="modalPosition" class="position mb-lg-5 mb-4">{{ modalPosition }}</h3>
                        <h5 class="mb-lg-4 mb-3 name">{{ modalName }}</h5>
                        <perfect-scrollbar class="scroll-prof">
                             <div class="prof text-justify" [innerHTML]="modalDetail"></div>
                        </perfect-scrollbar>
                    </div>
                    <div class="pict">
                        <img class="w-100 h-100" [src]="apiAsset + modalImg" [alt]="modalName">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


